// Pure data without JSX components
import { images } from "@/assets/images";

export const content = {
  metadata: {
    title: "Cove",
    description:
      "The money app that isn't boring. Save, invest, and grow your money with Cove.",
    url: "https://usecove.com/",
    icon: "https://usecove.com/favicon.ico",
    thumbnail: "https://usecove.com/opengraphimage.webp"
  },

  herosection: {
    herotagline: "High Yield Saving and Investing",
    heading: "We make finance fun.",
    subheading: "Finance apps are boring and stressful. Cove changes that.",
    insurance:
      "Cove is not a bank. Please see our footer for *, ** disclaimers and more information.",
    buttonslinks: {
      appstore:
        "https://apps.apple.com/us/app/cove-your-money-haven/id1589645033",
      playstore:
        "https://play.google.com/store/apps/details?id=com.EdenFinancialTechnologies.Eden"
    }
  },

  beforeaftersection: {
    heading: "Old way Vs. Cove",
    subheading: "Start an island and join the next generation of finance",
    beforelist: [
      "Saving feels like a chore",
      "Investing is too complex to start",
      "Financial apps leave you feeling stressed and unmotivated"
    ],
    afterlist: [
      "You're addicted to saving",
      "Investing just clicked",
      "You hit your goals without trying"
    ]
  },

  testimonials: {
    heading: "Wall of love",
    subheading:
      "We're proud to have a community of Covelings who love their islands",
    disclaimer: {
      text: `Names have been changed to protect client privacy. Testimonials are
        based on unique experiences from current clients and are not
        representative of all client experiences. Testimonials are unsolicited,
        and no cash or non-cash compensation is provided. Investing involves
        risk, including the possible loss of principal and fluctuation of value.
        Past performance is no guarantee of future results. Additional
        information about Eden Financial Technologies Inc. DBA Cove is available
        in its current disclosure documents, Form ADV, Form ADV Part 2A
        Brochure, and Client Relationship Summary report which are accessible
        online via the SEC's Investment Adviser Public Disclosure (IAPD)
        database at`,
      linkText: "IAPD - Investment Adviser Public Disclosure - Homepage",
      linkUrl: "https://www.adviserinfo.sec.gov",
      secNumber: "801-130646"
    },
    data: [
      {
        name: "Ben",
        age: "20",
        imgSrc: images.testimonials.ben,
        desc: "I absolutely love this app. If you have kids or are a beginner at investing and saving this app is a godsend. It makes saving money fun as opposed to regular bank account."
      },
      {
        name: "Sylvie",
        age: "18",
        imgSrc: images.testimonials.sylvie,
        desc: "I wasn't sure if I would use this but I really find it fun. I look forwards to the daily shipmemts and trying to find the more rare decorations to make my island special. Plus there's the bonus of saving money which make me feel great!"
      },
      {
        name: "Tom",
        age: "20",
        imgSrc: images.testimonials.tom,
        desc: "I am addicted. I check my crate every day to see what's new and find myself transferring money in to buy something all the time. I also can't bear the thought of loosing some of my legendary assets. I doubt I'll ever sell them"
      },
      {
        name: "Mammy",
        age: "20",
        imgSrc: images.testimonials.mammy,
        desc: "Imagine being addicted to saving money and managing your personal finance in a way that's innovative, smart and fun. Whereas most games of this caliber cost you money, this one saves your money for you while still providing the same level of fun."
      },
      {
        name: "Tina",
        age: "29",
        imgSrc: images.testimonials.allison,
        desc: "A unique and fun way of banking that mixes with a social media kinda experience 😜"
      }
    ],
    data2: [
      {
        name: "Allison",
        age: "22",
        imgSrc: images.testimonials.allison,
        desc: "By far best savings account ever! Customer service is always helpful when issues arise, which is something I haven't got at other finance apps. If you have trouble saving like I do, I totally recommend it. Seeing my savings grow in a way that isn't just numbers in black and white on paper is amazing. I get excited everyday to open my treasure boxes and decorate my island."
      },
      {
        name: "Tay",
        age: "24",
        imgSrc: images.testimonials.tay,
        desc: "So far I can see a lot of future potential in building a good value folder of investments in this game. The founders do everything to fix any and all issues! I highly recommend this game to anyone looking for a fun way to invest for future returns!"
      },
      {
        name: "Avery",
        age: "25",
        imgSrc: images.testimonials.avery,
        desc: "This app is in the early stages but has serious potential. I love the idea of gamifying a savings account. It's done in such a cool way with personalized islands decorated by your money. I can't wait to watch this app grow with time!"
      },
      {
        name: "Jacob",
        age: "34",
        imgSrc: images.testimonials.jacob,
        desc: "An exceptional way to save money! The app works well, it's simple and easy to use. Definitely recommend this for young people having trouble saving money."
      },
      {
        name: "Jerry",
        age: "20",
        imgSrc: images.testimonials.ben,
        desc: "The creator and his team came up with a great idea. You can Invest your Money And grow your savings. They came up with Great content. And one great thing about this game. The Admin will like to work with you to see if his investors have good ideas for the game that is rare.This is one of the greatest game ever I love it when you can grow your Island And invest in something you love to do. And yes, I do recommend this game. And thank you. Cove Team Keep up the great work."
      }
    ]
  },

  howitworkssection: {
    heading: "Get Started in Minutes",
    subheading: "Open your account securely. Your island awaits.",
    steps: [
      {
        title: "Create Your Account",
        description: "Sign up in under 2 minutes with secure identity verification. Your information is protected with bank-level encryption.",
        badge: "256-bit encryption"
      },
      {
        title: "Link Your Bank",
        description: "Connect securely through Plaid — the same technology trusted by Venmo, Robinhood, and thousands of apps. We never see your login credentials.",
        badge: "Powered by Plaid"
      },
      {
        title: "Make Your First Deposit",
        description: "Add funds instantly and start earning up to {apyRate}% APY right away. Your money is FDIC insured up to $1,000,000.",
        badge: "FDIC Insured**"
      },
      {
        title: "Stash Your First Decoration",
        description: "Browse the shop, pick a decoration you love, and watch it appear on your island. Your money becomes your world.",
        badge: "Your island awaits"
      }
    ],
    cta: {
      text: "Start Your Island — It's Free",
      subtext: "No minimum deposit required"
    }
  },

  benefitssection: {
    heading: "Grow your money, no stress required",
    subheading:
      "With simple ETF investing and up to {apyRate}%* APY on cash and stashes, Cove makes growing your wealth effortless.",
    list: [
      {
        title: "Turn financial goals into a fun, visual experience",
        description:
          "With Cove, saving is more than just numbers. Customize your virtual island with rare decorations that represent your progress. Every dollar saved brings you closer to a unique, personalized world that grows as you do."
      },
      {
        title: "Invest with ease and confidence",
        description:
          "Earn competitive interest rates on FDIC-insured savings** and SIPC-protected investments**. With Cove, your money works as hard as you do—without the stress of traditional financial tools."
      },
      {
        title: "A community that grows together",
        description:
          "Connect with other Covelings through leaderboards, quests, and a dedicated Discord community. Share tips, find motivation, and celebrate milestones with friends."
      },
      {
        title: "Securely link your bank account",
        description:
          "Cove works with Plaid to link your bank account, making deposits and withdrawals easy and secure."
      }
    ]
  },

  gamefeaturesection: {
    headline: "Why Cove Hits Different",
    subheadline: "Most finance apps feel like spreadsheets. Cove feels like a game you want to play every day.",
    features: [
      {
        title: "Daily Mystery Crates",
        hook: "Every morning reveals new rare decorations, but they're only available to stash today. Tomorrow brings a new selection.",
        benefit: "The same 'limited time' excitement that hooks you in games, but now it's building your savings",
        icon: "crate"
      },
      {
        title: "Login Streaks",
        hook: "Daily login streaks with escalating rewards that grow the longer you keep it going. Miss a day? Back to zero.",
        benefit: "That satisfying streak counter becomes your daily reminder to check in on your money",
        icon: "streak"
      },
      {
        title: "Quest Board",
        hook: "Daily, weekly, and monthly quests with rewards for completion. There's always something to work toward.",
        benefit: "Turn 'save $10' into a completionist's dopamine hit instead of a chore",
        icon: "quest"
      },
      {
        title: "100+ Collectible Decorations",
        hook: "Pokémon-style \"gotta catch 'em all\" collection with rarity tiers from Common to Mythic. Plus 50+ badges to earn.",
        benefit: "Complete the Decodex and you'll have over $2,000 saved without even thinking about it",
        icon: "collection"
      },
      {
        title: "Friends & Leaderboards",
        hook: "Visit friends' islands, compare collections, and compete across 8 leaderboards for Most Saved, Best Island, and more.",
        benefit: "Turn saving into a social flex instead of something you do alone",
        icon: "leaderboard"
      },
      {
        title: "Island Design",
        hook: "Build a truly unique island. Customize terrain, place beaches, shape the land, and arrange every decoration exactly where you want it.",
        benefit: "The more you invest in your island, the more you invest in your future",
        icon: "island"
      }
    ]
  },

  gettoknowussection: {
    heading: "Meet the team",
    subheading:
      "Cove was started by a group of college friends frustrated with how boring finance was. We would spend money on games and wondered - what if you could buy cool in-game items but keep the money? Nothing existed like that, so we built it.",
    profiles: [
      {
        name: "David Wolfenden",
        username: "@wolfdavo",
        title: "Cofounder and CEO",
        description:
          "David is an obsessive entrepreneur. He leads the Cove team with focus and passion, dedicated to building the future of finance no matter the obstacles. If he's not coding, designing, writing emails, or brainstorming the next big step for Cove, you'll find him chasing the best surf.",
        image: images.team.david,
        width: 370,
        height: 370,
        linkedin: "https://www.linkedin.com/in/david-wolfenden/",
        x: "https://x.com/itsdavidwolf",
        mt: "mt-4"
      },
      {
        name: "Liam Howell",
        username: "@liam",
        title: "Cofounder and CTO",
        description:
          "Liam leads Cove's tech vision, architecting the innovative features that make Cove intuitive and engaging. He works closely with the team, tackling complex challenges to deliver only the best to the Covelings. Beyond Cove, he's surfing, foraging, or camping in the great outdoors.",
        image: images.team.liam,
        width: 295,
        height: 287,
        linkedin: "https://www.linkedin.com/in/liam-howell13/",
        mt: "mt-6"
      },
      {
        name: "Sarah Mirsky-Terranova",
        username: "@sarah",
        title: "CCO",
        description:
          "Sarah brings her expertise as a compliance executive and lawyer to help navigate regulatory complexities with ease. She empowers the team to focus on delivering value to Covelings. In her personal time, Sarah enjoys traveling and spending quality moments with her daughters and husband.",
        image: images.team.sarah,
        width: 232,
        height: 217,
        linkedin: "https://www.linkedin.com/in/aeconsultingllc/",
        mt: "mt-1"
      },
      {
        name: "Ava Lazarov",
        username: "@ava",
        title: "Product & Operations",
        description:
          "Ava is Cove's product manager who turns data into strategic action. She has her hand in many projects across Cove so the team can stay focused on building with Covelings in mind. In her downtime, Ava loves to travel, curl up with a good book, or pursue her creative projects.",
        image: images.team.ava,
        width: 291,
        height: 266,
        linkedin: "https://www.linkedin.com/in/ava-lazarov-156544194/",
        mt: "mt-10"
      },
      {
        name: "Jake Tisdale",
        username: "@jake",
        title: "Marketing",
        description:
          "Jake combines creativity and strategy to lead Cove's Marketing and Communications. With a knack for crafting campaigns and making finance approachable, he turns marketing into stories people love. When he's not in marketing mode, Jake is hiking, snapping photos, or playing his favorite games.",
        image: images.team.jake,
        width: 305,
        height: 305,
        linkedin: "https://www.linkedin.com/in/jacob--tisdale/",
        mt: ""
      },
      {
        name: "Gabe Gintalas",
        username: "@gabeg",
        title: "Game Engineer",
        description:
          "Gabe's sole mission is bringing imagination to Cove. Inspired by his love of video games, he designs and builds the gaming systems that bring Cove to life. Aside from his role at Cove, Gabe is an outdoorsman, a passionate soccer fan, and an avid gamer.",
        image: images.team.gabe,
        width: 266,
        height: 266,
        linkedin: "https://www.linkedin.com/in/gabrielius-gintalas-a3523a252/",
        mt: "mt-1"
      }
    ]
  },

  faqsection: {
    heading: "Frequently Asked Questions",
    subheading: "FAQs",
    list: [
      {
        title: "Is my money safe?",
        answer:
          "Yes! Your stashes and cash in your account are FDIC insured up to $1,000,000**, and your investments are SIPC insured up to $500,000**. We utilize best-in-class security practices, and you can withdraw at any time. Our whole team is super active in Discord too, so if you have any questions or issues come up feel free to come chat with us!"
      },
      {
        title: "Can I earn yield?",
        answer:
          "Yes! You can earn up to {apyRate}%* APY on your stashes and cash in your account."
      },
      {
        title: "Can I invest in the stock market?",
        answer:
          "Yes! You can invest in a selection of ETFs that are selected by our team. We are constantly researching and testing new ETFs to ensure they are a good fit for our users."
      },
      {
        title: "Is Cove free?",
        answer:
          "It is free to open an account and save on Cove! Investments are charged a 0.8% advisory fee per year, with no additional or hidden fees. Our fee is billed monthly and is based on the average value of your investments throughout the month. This fee supports Cove's infrastructure costs and helps us take on a big and difficult industry; we appreciate your support immensely!"
      },
      {
        title: "Why do you need my social security number?",
        answer:
          "In accordance with the law, we use your social security number to verify your identity and protect against fraud. We never save your social security number in our system."
      },
      {
        title: "Can I use Cove if I'm not from the US?",
        answer:
          "Unfortunately, Cove is only available to those with a social security number and a US bank account. However, we are planning to expand access to those outside of the US in the near future."
      }
    ]
  },

  calltoaction: {
    heading: "Stop managing money. Start mastering the game.",
    subheading: "See your progress, build your wealth, and have fun doing it.",
    list: [
      "Start building your island for free",
      "Grow your savings effortlessly with up to {apyRate}% APY*",
      "Make saving and investing as fun as spending"
    ]
  },

  footer: {
    list: [
      { name: "The Game", href: "#gamefeaturesection" },
      { name: "Get Started", href: "#howitworkssection" },
      { name: "Reviews", href: "#testimonials" },
      { name: "Team", href: "#aboutus" },
      { name: "Blog", href: "/blog" },
      { name: "Families", href: "/families" },
      { name: "FAQs", href: "#faqsection" },
      { name: "Legal", href: "/legal" }
    ],
    links: [
      { name: "Privacy Policy", url: "/privacy-policy" },
      {
        name: "Terms of Service",
        url: "/legal/terms-of-service"
      },
      {
        name: "Investment Advisory Agreement",
        url: "/legal/iaa"
      },
      {
        name: "Alpaca Customer Agreement",
        url: "https://files.alpaca.markets/disclosures/library/AcctAppMarginAndCustAgmt.pdf"
      },
      {
        name: "Cash Sweep Program",
        url: "https://files.alpaca.markets/disclosures/Alpaca+FDIC+Bank+Sweep+Program+Terms+and+Conditions.pdf"
      },
      {
        name: "Cove Firm Brochure (ADV Part 2A)",
        url: "https://files.adviserinfo.sec.gov/IAPD/Content/Common/crd_iapd_Brochure.aspx?BRCHR_VRSN_ID=979558"
      },
      {
        name: "Cove Client Relationship Summary",
        url: "https://reports.adviserinfo.sec.gov/crs/crs_329900.pdf"
      },
      {
        name: "Referral Program Policy",
        url: "/legal/referral-program-policy"
      }
    ],
    privacypolicy: "/privacy-policy",
    socialmedia: {
      instagram: "https://www.instagram.com/use.cove/",
      linkedin: "https://www.linkedin.com/company/usecove/",
      facebook: "https://www.facebook.com/people/Cove-App/100070767042300/"
    }
  },

  navigationbar: {
    list: [
      { name: "Home", href: "/" },
      { name: "The Game", href: "#gamefeaturesection" },
      { name: "Get Started", href: "#howitworkssection" },
      { name: "Reviews", href: "#testimonials" },
      { name: "Team", href: "#aboutus" },
      { name: "Blog", href: "/blog" },
      { name: "Families", href: "/families" }
    ],
    buttonslinks: {
      gettheapp:
        "https://apps.apple.com/us/app/cove-your-money-haven/id1589645033"
    }
  }
};

// Social media data with icon mappings
export const socialData = [
  { name: "X", href: "https://x.com/use_cove", iconName: "FaXTwitter" },
  {
    name: "Instagram",
    href: "https://www.instagram.com/use.cove/",
    iconName: "FaInstagram"
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/usecove",
    iconName: "FaLinkedinIn"
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=100070767042300",
    iconName: "FaFacebook"
  },
  {
    name: "Discord",
    href: "https://discord.gg/NhxjaKRA9T",
    iconName: "FaDiscord"
  }
];
